
export const globals = {
    html_loading_gif: '<img src="assets/images/loading.gif">',
    html_small_loading_gif: '<img src="assets/images/loading_small.gif">'
};



// WEBPACK FOOTER //
// ./src/globals.ts